/** Currencies accepted for order monetary values across Klareo apps. */
export const CURRENCIES = ['EUR', 'USD', 'GBP'] as const;

/** Type for accepted currency codes. */
export type Currency = (typeof CURRENCIES)[number];

/** Default currency used where no real currency applies yet (e.g. a plan-less €0 bill). */
export const DEFAULT_CURRENCY: Currency = 'EUR';
